/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/ArticleTeaser/Bodytext/theme';

export const ArticleTeaserBodytextTheme = theme;
